import authService from 'modules/auth/services';
import authApis from 'modules/auth/services/apis';
import { IResponseData } from 'services/response';
import { useAppDispatch } from 'store/hooks';
import ModalChooseDevice, { useModalChooseDeviceRef } from './components/ModalChooseDevice';
import ModalDeviceType, { useModalDeviceTypeRef } from './components/ModalDeviceType';
import { setPageLoading } from 'widgets/PageLoading';
import storage from 'utils/sessionStorage';

const useDeviceSelection = (): [((store_id: string) => Promise<void>), JSX.Element] => {
  const dispatch = useAppDispatch();
  const chooseRef = useModalChooseDeviceRef();
  const deviceTypeRef = useModalDeviceTypeRef();
  const onChooseStore = async (store_id: string) => {
    storage.shop_id.set(store_id);
    setPageLoading(true);
    try {
      const res: IResponseData<number> = await authApis.totalStation(store_id);
      if (res.data.data) {
        dispatch(authService.slice.actions.async.getAllDevices.fetch(store_id));
        deviceTypeRef.current?.open(store_id, (device_type) => {
          chooseRef.current?.open(store_id, res.data.data, device_type);
        });
      }
    } catch (error) {
    } finally {
      setPageLoading(false);
    }
  };
  const context = <>
    <ModalChooseDevice ref={chooseRef} />
    <ModalDeviceType ref={deviceTypeRef} />
  </>;

  return [onChooseStore, context];
};

export default useDeviceSelection;
